export default __webpack_public_path__ + "static/media/play-button.b31e824e.svg";